import axios from 'axios'

var checkResponseError = (_this, data) => {
    if (data.errcode === 200) {
        return true
    } else if (data.errcode === 40001) {
        sessionStorage.removeItem("ewl_wms_token");
        _this.$Message.error("登录超时，请重新登录");
        _this.$router.push("/")
        return false
    } else {
        _this.$Message.error(data.msg);
        return false
    }
}
var loginCheckResponseError = (_this, data) => {
    if (data.errcode === 200) {
        return true
    } else if (data.errcode === 40001) {
        sessionStorage.removeItem("ewl_wms_token");
        _this.$Message.error("账号或密码错误");
        return false
    } else {
        _this.$Message.error(data.msg);
        return false
    }
}
var postData = (_this, url, data) => {
    return new Promise(function (resolve, reject) {
        axios({
            method:'post',
            url: url,
            data: JSON.stringify(data)
        }).then((response) =>{          //这里使用了ES6的语法
            // console.log(response.data)       //请求成功返回的数据
            if (checkResponseError(_this, response.data)) {
                resolve(response.data)
            } else {
                reject(response)
            }
        }).catch((error) =>{
            _this.$Message.error(error.message)
            reject(error)
        })
    })
}
var postLogin = (_this, url, data) => {
    return new Promise(function (resolve, reject) {
        axios({
            method:'post',
            url: url,
            data: JSON.stringify(data)
        }).then((response) =>{          //这里使用了ES6的语法
            // console.log(response.data)       //请求成功返回的数据
            if (loginCheckResponseError(_this, response.data)) {
                resolve(response.data)
            } else {
                reject(response)
            }
        }).catch((error) =>{
            _this.$Message.error(error.message)
            reject(error)
        })
    })
}
let postDataWhitToken = (_this, url, data) => {
    return new Promise(function (resolve, reject) {
        let token = sessionStorage.getItem("ewl_wms_token")
        if (!token || token === "") {
            _this.$Message.error("登录超时，请重新登录");
            _this.$router.push("/")
            reject();
        }
        axios({
            headers: {
                "Authorization": "Bearer " + token
            },
            method:'post',
            url: url,
            data: JSON.stringify(data)
        }).then((response) =>{          //这里使用了ES6的语法
            // console.log(response.data)       //请求成功返回的数据
            if (checkResponseError(_this, response.data)) {
                resolve(response.data)
            } else {
                reject(response)
            }
        }).catch((error) =>{
            _this.$Message.error(error.message)
            reject(error)
        })
    })
}
var getData = (_this, url, data) => {
    return new Promise(function (resolve, reject) {
        axios({
            method:'get',
            url: url,
            data: data
        }).then((response) =>{          //这里使用了ES6的语法
            // console.log(response.data)       //请求成功返回的数据
            if (checkResponseError(_this, response.data)) {
                resolve(response.data)
            } else {
                reject(response)
            }
        }).catch((error) =>{
            _this.$Message.error(error.message)
            reject(error)
        })
    })
    
}
export default {
    postData,
    getData,
    postDataWhitToken,
    postLogin
}